import React from 'react'
import "../assets/css/style.css"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, A11y } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import first from "../assets/img/testimonials1.jpg"
import second from "../assets/img/testimonials2.jpg"
import third from "../assets/img/testimonials3.jpg"
import fourth from "../assets/img/testimonials4.jpg"
import fifth from "../assets/img/testimonials5.jpg"

const Testimonials = () => {
  return (
    <section id="testimonials" class="testimonials section-bg">
    <div class="container">
        <div class="section-title">
            <h2>Testimonials</h2>
            <p>Explore the feedback from some of my satisfied clients.</p>
        </div>
        <Swiper
      // install Swiper modules
      modules={[Pagination, A11y]}
      spaceBetween={60}
      slidesPerView={2}
      pagination={{ clickable: true }}
      onSwiper={(swiper) => console.log(swiper)}
      onSlideChange={() => console.log('slide change')}
      autopaly= {{
        delay:2500, 
        disableOnInteraction:false,
      }}
    >
      <SwiperSlide>
      <div class="swiper-slide">
                    <div class="testimonial-item" data-aos="fade-up">
                        <p> <i class="bx bxs-quote-alt-left quote-icon-left"></i>Great work, super communicative, clear communication (English), and wonderful result. Great understanding of product dev from design through launch. <i
                                class="bx bxs-quote-alt-right quote-icon-right"></i></p> <img
                            src={first}
                            class="testimonial-img" alt=""/>
                        <h3>Kokuroku</h3>
                    </div>
                </div>
      </SwiperSlide>
      <SwiperSlide>
      <div class="swiper-slide">
                    <div class="testimonial-item" data-aos="fade-up">
                        <p> <i class="bx bxs-quote-alt-left quote-icon-left"></i> Extremely professional work. Timely communication and project planning to provide the best output. Extremely recommended!

<i
                                class="bx bxs-quote-alt-right quote-icon-right"></i></p> <img
                            src={second}
                            class="testimonial-img" alt=""/>
                        <h3>Saul Goodman</h3>
                    </div>
                </div>
      </SwiperSlide>
      <SwiperSlide>
      <div class="swiper-slide">
                    <div class="testimonial-item" data-aos="fade-up">
                        <p> <i class="bx bxs-quote-alt-left quote-icon-left"></i>Saqib is an amazing developer. He writes very clean code and is well versed in the latest technologies. If you want someone that is very productive go with him! <i
                                class="bx bxs-quote-alt-right quote-icon-right"></i></p> <img
                            src={third}
                            class="testimonial-img" alt=""/>
                        <h3>Teloty</h3>
                    </div>
                </div>
      </SwiperSlide>
      <SwiperSlide>
      <div class="swiper-slide">
                    <div class="testimonial-item" data-aos="fade-up">
                        <p> <i class="bx bxs-quote-alt-left quote-icon-left"></i>Nice, professional and dedicated <i
                                class="bx bxs-quote-alt-right quote-icon-right"></i></p> <img
                            src={fifth}
                            class="testimonial-img" alt=""/>
                        <h3>Nike</h3>
                    </div>
                </div>
      </SwiperSlide>
      {/* <SwiperSlide>
      <div class="swiper-slide">
                    <div class="testimonial-item" data-aos="fade-up">
                        <p> <i class="bx bxs-quote-alt-left quote-icon-left"></i> Saqib is THE BEST! Smart, intuitive, great communicator and on top of his game! Project was done and complete in less time than we thought initially, works flawlessly, and was launched yesterday! <i
                                class="bx bxs-quote-alt-right quote-icon-right"></i></p> <img
                            src={second}
                            class="testimonial-img" alt=""/>
                        <h3>Marcos</h3>
                    </div>
                </div>
      </SwiperSlide> */}
    </Swiper>
    </div>
</section>
  )
}

export default Testimonials